
import { Box, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    overflow: 'hidden',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    '&::after': {
      content: '""',
      position: 'absolute',
      inset: 0,
      background: 'rgba(0,0,0,0.10)',
      transition: 'background 200ms ease',
    },
    '&:hover::after': {
      background: 'rgba(0,0,0,0.45)',
    },
    '&:hover $content': {
      opacity: 1,
      transform: 'translateY(0)',
    },
    '&:hover $tileLogo': {
      opacity: 0,
      transform: 'scale(0.9)',
    },
  },

  tileLogo: {
    position: 'relative',
    zIndex: 1,
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    transition: 'opacity 200ms ease, transform 200ms ease',
  },

  content: {
    position: 'absolute',
    top: 24,
    left: 24,
    right: 24,
    bottom: 24,
    zIndex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
    padding: 24,
    backgroundColor: 'rgba(255,255,255,0.95)',
    borderRadius: 8,
    boxShadow: theme.shadows[3],
    opacity: 0,
    transform: 'translateY(8px)',
    transition: 'opacity 200ms ease, transform 200ms ease',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 12,
      padding: 16,
      opacity: 1,
      transform: 'none',
    },
  },

  contentImage: {
    width: '25%',
    height: 'auto',
    objectFit: 'contain',
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  textColumn: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      overflow: 'visible',
      textOverflow: 'unset',
      wordBreak: 'break-word',
    },
  },
}))

export const Tile = ({ bg, logo, title, contentImage, description, backgroundPosition }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root} sx={{ backgroundImage: `url(${bg})`, backgroundPosition }}>
      {logo && (
        <Box component="img" src={logo} alt="" className={classes.tileLogo} />
      )}

      <Box className={classes.content}>
        {contentImage && (
          <Box
            component="img"
            src={contentImage}
            alt=""
            className={classes.contentImage}/>
        )}
        <Box className={classes.textColumn}>
          {title && (
            <Typography
              sx={{
                color: '#000',
                fontFamily: 'Inter, sans-serif',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 700,
                lineHeight: '20px',
              }}>
              {title}
            </Typography>
          )}
          {description && (
            <Typography
              sx={{
                color: '#000',
                fontFamily: 'Inter, sans-serif',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '20px',
              }}>
              {description}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  )
}
